import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import LoginContentStep1 from '../../core/components/login/LoginContentStep1';
import LoginContentStep2 from '../../core/components/login/LoginContentStep2';
import LoginStep4 from '../../core/components/login/LoginStep4';
import LoginContentStep3 from '../../core/components/login/LoginContentStep3';
import { selectLoginModalStep } from '../../sell/selectors/sell-tickets';
import { setLoginModalStep } from '../../sell/actions/sell-tickets';
import { selectAuth } from '../../core/selectors/auth';
import { LOGIN_STEP_1, LOGIN_STEP_2, LOGIN_STEP_3, LOGIN_STEP_4 } from '../../sell/constants/modal';
import { CART_STEP_2 } from '../constants/steps';

const LoginContent = () => {
    const step = useSelector(selectLoginModalStep);
    const auth = useSelector(selectAuth);
    const navigate = useNavigate();
    const goToNextStep = () => navigate(`/cart/checkout/${CART_STEP_2}`);
    return (getContent(step, auth, goToNextStep));
};
const getContent = (step, auth, goToNextStep) => {
    switch (step) {
        case LOGIN_STEP_4:
            return <LoginStep4 auth={auth} goToNextStep={goToNextStep} targetPath={`/cart/checkout/${CART_STEP_2}`}/>;
        case LOGIN_STEP_2:
            return <LoginLayout><LoginContentStep2 auth={auth} goToNextStep={goToNextStep}/></LoginLayout>;
        case LOGIN_STEP_3:
            return <LoginLayout><LoginContentStep3 auth={auth} targetPath={`/cart/checkout/${CART_STEP_2}`}/></LoginLayout>;
        case LOGIN_STEP_1:
        default:
            return <LoginLayout><LoginContentStep1 auth={auth} targetPath={`/cart/checkout/${CART_STEP_2}`}/></LoginLayout>;
    }
};
const LoginLayout = ({ children }) => {
    const dispatch = useDispatch();
    return (
        <div className="login-container">
            <h4 className="mb-0"><FormattedMessage id="sing_in"/></h4>
            <p className="mb-3"><FormattedMessage id="start_journey"/>
                <Button variant="link" className="ms-md-2 m-0 p-0 text-decoration-none fs-6 border-0" onClick={() => dispatch(setLoginModalStep(LOGIN_STEP_4))}>
                    <FormattedMessage id="sing_up"/>
                </Button>
            </p>
            {children}
        </div>
    );
};

export default LoginContent;
